module.exports = __webpack_public_path__ + "static/media/asgard.b1a76623.png";